import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Response } from '@angular/http';
import { LoginModel } from '../login.model';
import { AuthService } from '../../shared/services/auth.service';
import { ControlBase, ControlTextbox, ControlCheckbox } from '../../shared/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { StorageService } from '../../shared/services/storage.service';
import { UserService } from '../../shared/services/user.service';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
    selector: 'appc-social-login',
    styleUrls: ['./social-login.component.scss'],
    templateUrl: './social-login.component.html'
})
export class SocialLoginComponent implements OnInit {
    constructor(public userService:UserService,
        public storageSvc:StorageService,
        private auth: AuthService, 
        private router: Router, 
        private authService: AuthService,  
        private storageService:StorageService, 
        private route:ActivatedRoute,
        private afAuth:AngularFireAuth) { }

    ngOnInit() { }

    signInWithGithub(): void {
        this.auth.githubLogin()
            .then((result) => this.postSignIn(result));
    }

    signInWithGoogle(): void {
        this.auth.googleLogin()
            .then((result) => this.postSignIn(result));
    }

    signInWithTwitter(): void {
        this.auth.twitterLogin()
            .then((result) => this.postSignIn(result));
    }

    signInWithFacebook(): void {
        this.auth.facebookLogin()
            .then((result) => this.postSignIn(result)
        );
    }
    signInWithLinkedIn(): void {
        //console.log('todo sigin with linked');
    }

    private postSignIn(result): void {
        this.route.params.subscribe((params: any) => {      
            let messageid = params['messageid'];
            if (messageid === 'forumauth') {
              alert('forum auth')
      
              this.router.routerState.root.queryParams.subscribe(queryparams => {
                var accesstoken = this.storageService.getItem('tokenId');
                this.afAuth.auth.currentUser.getToken(/* forceRefresh */ true).then(function (idToken) {
                  // Send token to your backend via HTTPS
      
                  let returnurl = queryparams['redirect_uri'];
                  let authurl = returnurl + "?token=" + idToken
                  // login successful so redirect to return url
                  console.log(" auth uri --> " + authurl)
                  window.location.href = authurl
                  
                }).catch(function (error) {
                  // Handle error
                });
      
      
      
              });
            }
      
            this.router.navigateByUrl('/orgsearch')
      
      
      
          });
    }


}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/sociallogin/social-login.component.ts